module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1302.d0cc3ff6.png";